// utils/themeVars.ts
import { MantineThemeOverride } from '@mantine/core';

export function applyThemeCssVariables(theme: MantineThemeOverride): void {
  const root = document.documentElement;
  if (!theme) return;

  const colors = theme.colors ?? {};
  Object.entries(colors).forEach(([colorName, colorShades]) => {
    if (!Array.isArray(colorShades)) return;

    colorShades.forEach((value, index) => {
      if (value) {
        root.style.setProperty(`--color-${colorName}-${index}`, value);
      }
    });
  });

  // Add other useful vars
  // root.style.setProperty('--radius-md', theme.defaultRadius?.toString() || '0.5rem');
  // root.style.setProperty('--font-family', theme.fontFamily || 'sans-serif');
  // root.style.setProperty('--font-size-base', '14px');

  // Spacing can be manually defined if needed
  // root.style.setProperty('--spacing-md', '1rem');
}
